import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import GalleryPage from './pages/GalleryPage';
import HomePage from './pages/HomePage';
import InfoPage from './pages/InfoPage';
import MaintainPage from './pages/MaintainPage';
import AdminLogin from './pages/AdminLogin';
import AdminPanel from './pages/AdminPanel';
import PageLoader from './components/PageLoader';

const routes = {
  '/': HomePage,
  '/Home/Index': HomePage,
  '/Home/About': AboutPage,
  '/Home/Contact': ContactPage,
  '/Home/Gallery': GalleryPage,
  '/Home/Info': InfoPage,
  '/Home/Maintain': MaintainPage,
  '/about': AboutPage,
  '/services': ContactPage,
  '/contact': InfoPage,
  '/Home/Login': AdminLogin,
  '/login': AdminLogin,
  '/admin/login': AdminLogin,
  '/admin': AdminPanel,
  '/adminpanel': AdminPanel,
  '/gallery': GalleryPage
};

const pageTitles = {
  '/': 'Home | Revival Pharmacy',
  '/Home/Index': 'Home | Revival Pharmacy',
  '/Home/About': 'Minor Ailments & Conditions | Revival Pharmacy',
  '/about': 'Minor Ailments & Conditions | Revival Pharmacy',
  '/Home/Contact': 'Services | Revival Pharmacy',
  '/services': 'Services | Revival Pharmacy',
  '/Home/Gallery': 'Gallery | Revival Pharmacy',
  '/gallery': 'Gallery | Revival Pharmacy',
  '/Home/Info': 'Contact | Revival Pharmacy',
  '/contact': 'Contact | Revival Pharmacy',
  '/Home/Maintain': 'Maintenance | Revival Pharmacy',
  '/Home/Login': 'Admin Login | Revival Pharmacy',
  '/login': 'Admin Login | Revival Pharmacy',
  '/admin/login': 'Admin Login | Revival Pharmacy',
  '/admin': 'Admin Panel | Revival Pharmacy',
  '/adminpanel': 'Admin Panel | Revival Pharmacy',
};

function usePageEnhancements() {
  useEffect(() => {
    const $ = window.jQuery;
    if ($ && $.fn && $.fn.owlCarousel) {
      $('.main-slider-carousel').each(function () {
        const $element = $(this);
        if (!$element.hasClass('owl-loaded')) {
          $element.owlCarousel({
            items: 1,
            loop: true,
            autoplay: true,
            autoplayTimeout: 5000,
            nav: false,
            dots: true,
            smartSpeed: 800,
            autoHeight: true
          });
        }
      });
      $('.two-item').each(function () {
        const $element = $(this);
        if (!$element.hasClass('owl-loaded')) {
          $element.owlCarousel({
            items: 2,
            loop: true,
            autoplay: true,
            margin: 30,
            nav: true,
            navText: [
              '<span aria-hidden="true">&#8249;</span><span class="sr-only">Previous testimonial</span>',
              '<span aria-hidden="true">&#8250;</span><span class="sr-only">Next testimonial</span>'
            ],
            dots: true,
            responsive: { 0: { items: 1 }, 768: { items: 2 } }
          });
        }
      });
    }
  });
}

// Routes that should render standalone (no header/footer)
const standaloneRoutes = ['/Home/Login', '/login', '/admin/login', '/admin', '/adminpanel'];

export default function App() {
  const location = useLocation();
  const [showScrollTop, setShowScrollTop] = useState(false);
  const Page = routes[location.pathname] || HomePage;
  const pageName = pageTitles[location.pathname] || 'Revival Pharmacy';

  // Check if this is a standalone page (login, etc.)
  const isStandalone = standaloneRoutes.includes(location.pathname);

  useEffect(() => {
    document.title = pageName;
    window.scrollTo(0, 0);
  }, [pageName]);

  useEffect(() => {
    if (isStandalone) return;
    const handleScroll = () => {
      const isHome = location.pathname === '/' || location.pathname === '/Home/Index';
      const threshold = isHome ? 520 : 350;
      if (window.scrollY > threshold) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [location.pathname, isStandalone]);

  usePageEnhancements();

  const handleScrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Standalone pages (Login, etc.) — render with no header/footer/chrome
  if (isStandalone) {
    return (
      <div className="standalone-page">
        <Page />
      </div>
    );
  }

  return (
    <div className="page-wapper home-page-one">
      <PageLoader pageKey={location.pathname} />
      <Header />
      <main className="main-content">
        <Page />
      </main>
      <Footer />
      <a
        href="#header-one"
        id="scroll"
        className={`default-bg${showScrollTop ? ' is-visible' : ''}`}
        aria-label="Back to top"
        onClick={handleScrollToTop}
      >
        <span></span>
      </a>
    </div>
  );
}
